import { Box, Typography, Container, IconButton } from "@mui/material";
import { useRef, useEffect, useState } from "react";
import About from "../About/About";
import HomeBanner from "../../Components/HomeBanner/HomeBanner";
import Category from "../Category/Category";
import { getData } from "../../Webservice/Webservice";
import Layout1 from "../../Components/HomeLayouts/Layout1";
import Layout2 from "../../Components/HomeLayouts/Layout2";
import Layout3 from "../../Components/HomeLayouts/Layout3";
import Layout4 from "../../Components/HomeLayouts/Layout4";
import Layout5 from "../../Components/HomeLayouts/Layout5";
import LayoutSkeleton from "../../Components/Skeleton/LayoutSkeleton";
import ProductCard from "../../Components/ProductCard/ProductCard";
import { getToken, getUser } from "../../Utils/authHelper";
import ComboSection from "../../Components/ComboSection/ComboSection";
import BogoSection from "../../Components/BogoSection/BogoSection";
import ShopByPrice from "../../Components/ShopByPrice/ShopByPrice";
import BrandSection from "../../Components/BrandSection/BrandSection";

const rubikfont = {
  fontFamily: "Rubik, san-serif"
};
function Home() {
  const scrollContainerRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const [layouts, setLayouts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [recentlyViewed, setRecentlyViewed] = useState([]);

  useEffect(() => {
    const user = getUser();
    const userId = user?._id || user?.id || 'guest';
    const userType = user?.customerType || 'customer'; // Default to customer (B2C) for guests

    let list = JSON.parse(localStorage.getItem(`recentlyViewed_${userId}`) || localStorage.getItem('recentlyViewed') || '[]');

    // Filter by visibility for safety
    list = list.filter(p => {
      if (!p.visibility || p.visibility.length === 0) return userType === 'customer'; // Legacy B2C support
      if (userType === 'business') return p.visibility.includes('b2b');
      return p.visibility.includes('b2c');
    });

    setRecentlyViewed(list);
  }, []);

  const checkScrollButtons = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  useEffect(() => {
    checkScrollButtons();
    window.addEventListener("resize", checkScrollButtons);
    return () => window.removeEventListener("resize", checkScrollButtons);
  }, []);

  // Auto scroll functionality
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const autoScroll = setInterval(() => {
      const { scrollLeft, scrollWidth, clientWidth } = container;

      if (scrollLeft >= scrollWidth - clientWidth - 10) {
        container.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        container.scrollBy({ left: 300, behavior: "smooth" });
      }

      setTimeout(checkScrollButtons, 500);
    }, 3000);

    return () => clearInterval(autoScroll);
  }, []);

  useEffect(() => {
    const fetchLayouts = async () => {
      try {
        const response = await getData("homepage/layout/list?page=1&limit=10&productLimit=12");
        if (response && response.layout) {
          const randomizedLayouts = response.layout.map(layout => ({
            ...layout,
            product_id: (layout.product_id || [])
              .sort(() => 0.5 - Math.random())
              .slice(0, 12)
          }));
          setLayouts(randomizedLayouts);
        }
      } catch (error) {
        console.error("Error fetching layouts:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchLayouts();
  }, []);

  return (
    <Box sx={{ width: "100%", minHeight: "100vh", overflowX: "hidden" }}>

      <HomeBanner />


      <Category />

      {/* Shop By Brand — right after Our Collections */}
      <BrandSection />

      {/* Combo Packs Section */}
      <ComboSection />

      {/* Shop By Price */}
      <ShopByPrice />

      {/* BOGO Deals Section */}
      <BogoSection />


      {/* Recently Viewed (Logged In Only) */}
      {/* {recentlyViewed.length > 0 && (
        <Box sx={{ py: { xs: 1, md: 2 }, bgcolor: "#fff", position: "relative" }}>
          <Container maxWidth="xl">
            <Box sx={{ mb: 4, display: "flex", justifyContent: "space-between", alignItems: "flex-end", borderBottom: "1px solid #f0f0f0", pb: 2 }}>
              <Box>
                <Typography sx={{ fontSize: "12px", fontWeight: 500, letterSpacing: "3px", color: "#C8A054", textTransform: "uppercase", mb: 1, ...rubikfont }}>
                  Your History
                </Typography>
                <Typography sx={{ fontSize: { xs: "22px", sm: "32px" }, fontWeight: 500, color: "#111", ...rubikfont, textTransform: "uppercase", lineHeight: 1 }}>
                  RECENTLY VIEWED
                </Typography>
              </Box>
            </Box>
            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "repeat(2, 1fr)", sm: "repeat(3, 1fr)", md: "repeat(4, 1fr)", lg: "repeat(6, 1fr)" }, gap: { xs: 1.5, sm: 2, md: 2.5 } }}>
              {recentlyViewed.map((product) => (
                <ProductCard key={product._id} product={product} />
              ))}
            </Box>
          </Container>
        </Box>
      )} */}

      {/*Layout sections */}
      {loading ? (
        Array.from(new Array(5)).map((_, index) => (
          <LayoutSkeleton key={index} />
        ))
      ) : (
        layouts.map((layoutData) => {
          const rawName = layoutData.layoutId?.name || "";
          const normalizedName = rawName.toLowerCase().replace(/[^a-z0-9]/g, "");
          const products = layoutData.product_id || [];

          if (products.length === 0) {
            return null; // Skip layouts with no products
          }


          // Use Layout1 as a default fallback if the specific name doesn't match
          const LayoutComponent = {
            layout1: Layout1,
            layout2: Layout2,
            layout3: Layout3,
            layout4: Layout4,
            layout5: Layout5,
          }[normalizedName] || Layout1;

          return (
            <LayoutComponent key={layoutData._id} data={layoutData} />
          );
        })
      )}

      {/* <About /> */}


    </Box>
  );
}

export default Home;
